import RepositoryEntry from './RepositoryEntry';

/**
 * InstructionsPage class handles the fetching and setting of content, language code, and type.
 * It also initializes the view model for the scope.
 */
class InstructionsPage extends RepositoryEntry {
    /**
     * Constructor for InstructionsPage class.
     */
    constructor(entry, $injector) {
        super(entry, $injector);
        
        this.accessables({
            'content'     : String,
            'languageCode': String
        });

        this.readables({
            'type'  : String
        });
    }

}


export default InstructionsPage;